import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { saveAs } from 'file-saver';
import {
  DataResponse,
  Filter,
  ExportTableType
} from '@portal/app/shared/types';
import { DatasetBaseService } from '@portal/app/shared/services/dataset-base.service';
import { ViewStore } from '@portal/app/shared/state/view.store';
import { DateTimeService } from '@portal/app/shared/services/date-time.service';

@Injectable({
  providedIn: 'root'
})
export class DatasetExportService extends DatasetBaseService<DataResponse> {
  constructor(
    private readonly http: HttpClient,
    protected readonly viewStore: ViewStore,
    protected readonly dateService: DateTimeService
  ) {
    super(viewStore, dateService);
  }

  getExportParams(): Params {
    return {
      format: 'csv',
      showFooter: false,
      literalId: 'mimComparisonData'
    };
  }

  exportData(filters: Filter[], format: ExportTableType) {
    const queryParams = this.getQueryParams(filters);
    const exportParams = this.getExportParams();
    const params = {
      ...queryParams,
      exportObjParams: {
        ...exportParams,
        format
      }
    };

    return this.http
      .post(
        `${DatasetBaseService.measuredUriV2}dataviz/data/export-data-set`,
        params,
        { responseType: 'blob' }
      )
      .subscribe((response) => {
        const filename = `${queryParams.clientId}-${queryParams.brandId}-${exportParams.literalId}.${format}`;
        saveAs(response, filename);
      });
  }
}
